import { uiText } from '@/i18n/interface';

import { toast } from "@/hooks/use-toast";
import { supabase } from '@/integrations/supabase/client';

export const useStudentDeletion = () => {
  const deleteStudent = async (studentId: string, studentName: string) => {
    try {
      console.log('Starting MASTER deletion process for student:', studentId);

      // First, let's verify the student exists
      const { data: existingStudent, error: checkError } = await supabase
        .from('profiles')
        .select('id, first_name, last_name')
        .eq('id', studentId)
        .single();

      if (checkError) {
        console.error('Error checking student existence:', checkError);
        toast({
          title: uiText("Error"),
          description: uiText("Student not found or error checking student"),
          variant: "destructive"
        });
        return;
      }

      console.log('Student found, proceeding with MASTER deletion:', existingStudent);

      // The key change: Delete from auth.users instead of profiles
      // This will automatically cascade and delete all related records
      const { error: authDeleteError } = await supabase.auth.admin.deleteUser(studentId);

      if (authDeleteError) {
        console.error('Error deleting user from auth:', authDeleteError);
        toast({
          title: uiText("Error"),
          description: "Master deletion failed: " + authDeleteError.message,
          variant: "destructive"
        });
        return;
      }

      console.log('✅ MASTER DELETION SUCCESSFUL - User deleted from auth, all records eliminated via CASCADE');

      toast({
        title: uiText("Success"),
        description: uiText("{{value0}} has been permanently removed from the dojo (Master Delete)", { value0: studentName })
      });

    } catch (error) {
      console.error('Master deletion error:', error);
      toast({
        title: uiText("Error"),
        description: uiText("Master deletion failed. System error occurred."),
        variant: "destructive"
      });
    }
  };

  return { deleteStudent };
};
